import { render } from "./createOrder.vue?vue&type=template&id=50449470"
import script from "./createOrder.vue?vue&type=script&lang=js"
export * from "./createOrder.vue?vue&type=script&lang=js"

import "./createOrder.vue?vue&type=style&index=0&id=50449470&lang=less"
script.render = render

export default script